import { route } from "quasar/wrappers";
import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import routes from "./routes";
import { auth } from "~/core";
import { Log } from "~/extensions/utils";
import { myPageStore } from "~/store/MyPageStore";
import { MsgBox } from "~/components/MsgBox";
import { commonStore } from "~/store/CommonStore";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { routeManager } from "./RouteManager";
import { userType, LatestResultStatus, LatestAsyncStatus } from "~/extensions/utils/DefineTypes";
export default route(function ( /* { store, ssrContext } */) {
    const createHistory = process.env.VUE_ROUTER_MODE === "history" ? createWebHistory : createWebHashHistory;
    const Router = createRouter({
        scrollBehavior: () => ({ left: 0, top: 0 }),
        routes,
        // Leave this as is and make changes in quasar.conf.js instead!
        // quasar.conf.js -> build -> vueRouterMode
        // quasar.conf.js -> build -> publicPath
        history: createHistory(process.env.MODE === "ssr" ? "" : process.env.VUE_ROUTER_BASE)
    });
    const log = Log.create("router");
    const noAuthPages = ["timeout", "password-reissue-entry", "password-reissue-check", "password-reissue-complete"];
    let needShowErrorDialog = false;
    const targetRoutes = ["shomei-list", "taikyo", "taikyo-room-list", "taikyo-applied-list"];
    // eslint-disable-next-line complexity
    Router.beforeEach(async (to, from) => {
        const adminDomains = Object.values(commonStore.domainConfig);
        const isAdminDomain = adminDomains.includes(window.location.hostname);
        if (isAdminDomain && (to.name === "login" || to.path === "/login")) {
            return { name: "mt-login" };
        }
        if (!isAdminDomain && (to.name === "mt-login" || to.matched.some(route => route.meta.adminOnly))) {
            return { name: "404" };
        }
        if (to.name != null && noAuthPages.includes(to.name.toString())) {
            return true;
        }
        if (!auth.isAuthenticated) {
            if (to.name !== "login" && to.name !== "mt-login" && to.name !== "") {
                await auth.init();
            }
        }
        //Login, 404ループ対策
        if (to.name === "login" || to.name === "mt-login" || to.name === "404") {
            return true;
        }
        //認証情報を再取得しても未認証ならログインへ
        if (!auth.isAuthenticated) {
            return { name: "login" };
        }
        // 共通情報ストアの初期化確認
        if (commonStore.initError) {
            return { name: "404" };
        }
        //認証済みの場合
        if (auth.isAuthenticated) {
            // 利用規約ループ対策
            if (to.name === "terms-of-use-confirm") {
                return true;
            }
            // 利用規約
            if (auth.isTenant && !auth.user?.isImpersonation && !auth.userInfo.isAgreeTermsOfUse) {
                if (to.name !== "terms-of-use-confirm") {
                    return { name: "terms-of-use-confirm" };
                }
            }
            //ログイン・利用規約画面以外は、最新情報取得（基本）APIのレスポンスを待つ
            if (auth.isTenant && to.name !== "login" && to.name !== "terms-of-use-confirm") {
                try {
                    Loading.show();
                    await myPageStore.waitForBasic();
                }
                catch (ex) {
                    await MsgBox.error(commonStore.messages.PE0001);
                }
                finally {
                    Loading.hide();
                }
            }
            // 個人情報ストアの取得に失敗/取得した結果、入居契約が0件だった場合
            if (myPageStore.loadError) {
                try {
                    await auth.logout();
                }
                catch (ex) {
                    auth.logoutLocal();
                }
                finally {
                    routeManager.reset();
                }
                await MsgBox.error(commonStore.messages.PE0001);
                return { name: "404" };
            }
            ///最新情報取得結果がDBフォールバック or エラー時、ダイアログ表示＋トップページ遷移
            //最新情報取得（入居契約・マスタ）が取得中の場合、ローディング表示
            if (auth.isTenant && targetRoutes.includes(to.name)) {
                Loading.show({ message: commonStore.messages.PI0015 });
                try {
                    const nyukyoStatus = await myPageStore.waitForNyukyo();
                    if ([LatestResultStatus.Error, LatestResultStatus.Fallback].includes(myPageStore.resultStatus) || nyukyoStatus === LatestAsyncStatus.Error) {
                        needShowErrorDialog = true;
                        return { name: "top" };
                    }
                }
                finally {
                    Loading.hide();
                }
            }
            if (auth.isTenant) {
                if (!auth.user?.isImpersonation) {
                    if (auth.user?.userType === userType.Kojin) {
                        // メールアドレス変更
                        if (!myPageStore.loadError && myPageStore.resultStatus === LatestResultStatus.Success && !myPageStore.personal.hasMailAddress) {
                            if (to.name !== "mailaddress-change" && to.name !== "mailaddress-check" && to.name !== "mailaddress-change-complete") {
                                return { name: "mailaddress-change" };
                            }
                        }
                    }
                }
            }
        }
        return true;
    });
    Router.afterEach(async (to, from, failure) => {
        let bots = document.getElementsByClassName("widget-5489");
        if (bots.length > 0) {
            let bot = bots[0];
            bot.style.setProperty("display", to.name === "top" || to.name === "login" ? "block" : "none", "important");
        }
        if (to.name === "top" && needShowErrorDialog) {
            needShowErrorDialog = false;
            await MsgBox.error(commonStore.messages.PE0001);
        }
    });
    return Router;
});
